import { render, staticRenderFns } from "./GiftShop.vue?vue&type=template&id=6651a279"
import script from "./GiftShop.vue?vue&type=script&lang=js"
export * from "./GiftShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports